import React, {useContext, useEffect, useMemo, useState} from "react";
import {useNavigate, useParams} from 'react-router-dom'
import {
    alpha,
    Box,
    Button,
    Chip,
    Fab,
    Grow, Icon,
    LinearProgress, ListItemIcon,
    Snackbar,
    Stack,
    Tab,
    Tabs,
    Typography
} from "@mui/material";
import {DataGrid, itIT} from '@mui/x-data-grid'
import UserService from "../../services/user.service";
import {Alert} from "@mui/lab";
import CustomGridToolbar from "../../components/data-grid/CustomGridToolbar";
import useAxios from "axios-hooks";
import SettingsService, {forms} from "../../services/settings.service";
import _, {each, filter, find, isEmpty} from 'lodash'
import {
    Archive,
    CachedOutlined,
    Check,
    CheckCircle,
    Clear,
    Close, FolderSharedOutlined, Lock, LockOpen,
    PersonAdd, PersonAddAlt1Outlined, PersonAddDisabledOutlined,
    PersonAddOutlined, Preview,
    Refresh
} from "@mui/icons-material";
import {API_URL, baseEventUrl} from "../../config";
import axios from "axios";
import CustomBackdrop from "../../components/CustomBackdrop";
import CustomPageHeader from "../../components/CustomPageHeader";
import CustomToggleGraph from "./CustomToggleGraph";
import CustomDashboardGraph from "../../components/charts/CustomDashboardGraph";
import {GlobalContext} from "../../state/global";
import ColumnsService from "../../services/columns.service";
import {customTheme, paletteKampaay} from "../../theme/customTheme";
import CustomTooltip from "../../components/CustomTooltip";
import AddUserDialog from "./AddUserDialog";
import ArchivedUsersDialog from "./ArchivedUsersDialog";
import MultipleSelection from "./MultipleSelection";
import CheckIn from "../CheckIn";
import {QrCodeAppCheckin} from "../Login";
import IconButton from "@mui/material/IconButton";
import MenuItem from "@mui/material/MenuItem";
import FormCompletedCustomChip from "./FormCompletedCustomChip";
import {setGlobalSettings} from "../../state/global/globalActions";

const Iscrizioni = ({readOnly}) => {
    const {event_id} = useParams()
    let navigate = useNavigate()

    const [globalState, dispatch] = useContext(GlobalContext)
    const {settings, dataStructures} = globalState

    const [pageSize, setPageSize] = useState(10)
    const [addUserDialogState, setAddUserDialogState] = useState({ open: false })

    const _forms = useMemo(() => {
        if (!settings || !dataStructures)
            return null
        return SettingsService.getForms(settings, dataStructures, readOnly)
    }, [settings, dataStructures])

    const [openArchivedDialog, setOpenArchivedDialog] = useState(false)

    const [activeForm, setActiveForm] = React.useState(null);
    const handleChangeActiveTab = (event, newValue) => {
        if(newValue === _forms.length)
            setOpenArchivedDialog(true)
        else
            setActiveForm(_forms[newValue]);
    };

    useEffect(() => {
        if (_forms) {
            setActiveForm(_forms[0])
        }
    }, [_forms])

    const [allUsersFlag, setAllUsersFlag] = useState(true)
    const [{data: allUsers, loading: loadingUsers, error: errorUsers}, fetchUsers] = useAxios(
        UserService.usersUrl({event_id: event_id, archived: false, all: allUsersFlag}), {method: "GET", useCache: false, manual: false}
    )

    const users = useMemo(() => {
        if (!allUsers || !_forms)
            return null
        else return allUsers
    }, [allUsers, _forms])

    const usersPerForm = useMemo(() => {
        if (!users)
            return {}

        const res = []

        each(_forms, (form) => {
            res[form.id] = _.orderBy(_.filter(users, function (o) {
                return true//o[form.id] === true || !!o[form.id] || !!o[form.timelineField]
            }),
                [form.id, form.id + '._seconds'], ['asc', 'desc'])
            if (form.id === forms.CHECKIN.id) {
                res[forms.CHECKIN.id] = _.orderBy(_.filter(users, ['partecipazione', 'si']), ['checkin', 'checkedInAt._seconds'], ['asc', 'desc'])
            }
        })

        return res
    }, [users])

    const [filteredUsers, reports] = useMemo(() => {
        if (!usersPerForm || !activeForm)
            return [[], null]

        const _filteredUsers = usersPerForm[activeForm.id]

        let _reports = {}

        if (forms.CHECKIN.id === activeForm.id) {
            _reports = {
                'Partecipanti fisici': _.filter(_filteredUsers, ['partecipazione', 'si']).length,
                'Check-in effettuati': _.filter(_filteredUsers, ['checkin', true]).length,
            }
        } else {
            _reports = {
                'Utenti totali': _filteredUsers?.length,
                'Partecipanti fisici': _.filter(_filteredUsers, ['partecipazione', 'si']).length,
                'Partecipanti in streaming': _.filter(_filteredUsers, ['partecipazione', 'online']).length,
                'Non partecipanti': filter(_filteredUsers, ['partecipazione', 'no']).length,
                'Check-in effettuati': _.filter(_filteredUsers, ['checkin', true]).length,
            }
        }

        //console.log("_filteredUsers:", _filteredUsers)

        return [_filteredUsers, _reports]
    }, [usersPerForm, activeForm])

    const [{data: config, loading: loadingConfig}, refetchConfig] = useAxios(ColumnsService.columnsUrl(event_id), {
        method: "GET", useCache: false
    })

    const [columnVisibilityModel, setColumnVisibilityModel] = React.useState({});

    useEffect(() => {
        if (config)
            setColumnVisibilityModel(config[activeForm?.id]?.defaultVisibilityModel)
    }, [config, activeForm])

    const checkinUser = async (id) => {
        //console.log("id:", id)
        await axios.get(`${API_URL}participantsFisici/${event_id}/${id}/checkin`)
            .then(() => fetchUsers())
            .catch(err => {
                //console.log("err:", err)
                setError(err.response?.data?.error || "Errore")
            })
    };

    const resetCheckInUser = async (id) => {
        await axios.get(`${API_URL}participantsFisici/${event_id}/${id}/reset`)
            .then(() => fetchUsers())
            .catch(err => setError(err.response))
    };

    const columns = useMemo(() => {
        if(!globalState.dataStructures)
            return []

        if (activeForm?.id === forms.CHECKIN.id) {
            const checkInCols = [{
                field: "action",
                headerName: "Check-in",
                sortable: false,
                flex: 1,
                renderCell: (params) => {
                    const onClick = async (e) => {
                        e.stopPropagation(); // don't select this row after clicking
                        await checkinUser(params.id)
                    };
                    const onClickReset = async (e) => {
                        e.stopPropagation(); // don't select this row after clicking
                        await resetCheckInUser(params.id)
                    };

                    return !params.row.checkin ?
                        <CustomTooltip title={'Segna check-in'} children={
                            <IconButton onClick={onClick}>
                            <PersonAddAlt1Outlined/>
                        </IconButton>}/>
                        :
                        <CustomTooltip title={'Resetta check-in'} children={
                            <IconButton onClick={onClickReset}>
                                <PersonAddDisabledOutlined/>
                            </IconButton>}/>
                }
            }]

            return ColumnsService
                .getColumns(globalState.dataStructures[activeForm?.id], fetchUsers)
                .concat(checkInCols)
        }

        return ColumnsService
            .getColumns(globalState.dataStructures[activeForm?.id], fetchUsers)
            .concat([{
                field: activeForm?.id,
                headerName: "Data Completamento",
                sortable: true,
                flex: 1.1,
                type: 'dateTime',
                hideable: false,
                valueGetter: (params) => {
                    return params.value?._seconds ?
                        new Date(params.value?._seconds * 1000)
                        : params.value
                },
                valueFormatter: (params) => {
                    return (params.value?._seconds ?
                        new Date((params.value?._seconds * 1000)).toLocaleString('it-IT').replace(',', ' -')
                        : params.value ?
                            new Date(params.value).toLocaleString('it-IT').replace(',', ' -')
                            : "Non completato");
                },
                renderCell: (params) =>
                    <FormCompletedCustomChip completionField={params.value}/>
            }])
    }, [globalState.dataStructures, activeForm])

    const handleSaveConfiguration = (newModel) => {
        setTimeout(function () {
            ColumnsService.saveDefaultVisibilityModel(activeForm?.id, newModel)
                .catch((err) => {
                    console.log("err:", err)
                    //setMessage({show: true, loading: false, text: "Configurazione non salvata", severity: "error"})
                })
                .finally(() => setColumnVisibilityModel(newModel))
        }, 200);
    }

    const [error, setError] = useState(null)

    const handleCloseError = () => {
        setError(null)
    }

    const [graphMode, setGraphMode] = useState(false);

    const handleGraphMode = (event, newMode) => {
        if (newMode !== null)
            setGraphMode(newMode);
    };

    const handleAddParticipant = () => {
        setAddUserDialogState({...addUserDialogState, open: true})
    }

    const handleCloseAddUserDialog = (res) => {
        if(res?.status === 'success') {
            fetchUsers().then(() => {
                if(res?.userId)
                    navigate(`/${event_id}/iscrizioni/user/`+res?.userId, {state: {activeFormId: res.formId}})
            })
        }
        setAddUserDialogState({...addUserDialogState, open: false})
    }

    /** SELEZIONE MULTIPLA */
    const [checkboxSelection, setCheckboxSelection] = useState(false);
    const [rowSelectionModel, setRowSelectionModel] = useState([]);

    useEffect(() => {
        if(!checkboxSelection)
            setRowSelectionModel([])
    }, [checkboxSelection])

    const handleToggleRegistrationsClosed = () => {
        axios.post(SettingsService.settingsUrl(event_id),
            {
                registrationClosed: !settings.registrationClosed
            })
            .then((res) => {
                dispatch(setGlobalSettings({
                    ...globalState.settings,
                    registrationClosed: !settings.registrationClosed
                }))
            })
            .catch((err) => console.log("err:", err))
    }

    return (
        <Box position={'sticky'} top={'-180px'}>
            <CustomBackdrop open={loadingUsers} children={false}/>
            <Snackbar open={!!error} autoHideDuration={6000} onClose={handleCloseError}>
                <Alert elevation={6} variant={"filled"} onClose={handleCloseError} severity="error"
                       sx={{width: '100%'}}>
                    {error}
                </Alert>
            </Snackbar>
            <Box>
                <Box mb={2} display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
                    <Box display={'flex'} alignItems={'center'}>
                        <CustomPageHeader title={'Elenco Iscrizioni'} //subtitle={'Elenco delle iscrizioni all\'evento'}
                                          refresh={fetchUsers}/>
                        {/*globalState?.authState?.isAdmin &&
                            <CustomTooltip title={"Mostra tutti gli utenti caricati"}
                                           children={
                                               <Stack alignItems={'center'}>
                                                   <Switch
                                                       size={'small'}
                                                       checked={allUsersFlag}
                                                       onChange={() => setAllUsersFlag(!allUsersFlag)}
                                                       inputProps={{'aria-label': 'controlled'}}
                                                   />
                                                   <AllInclusive fontSize={'small'}/>
                                               </Stack>}
                            />*/}
                        {!readOnly &&
                            <CustomTooltip
                                title={'Aggiungi nuovo partecipante'}
                                children={
                                    <Button variant={'outlined'} color={'accent'}
                                            size={'small'}
                                            sx={{ml: 1}}
                                            //disabled={!activeForm?.main}
                                            startIcon={<PersonAddOutlined/>}
                                            onClick={handleAddParticipant}>
                                        Aggiungi
                                    </Button>
                                }
                            />}
                        {activeForm?.main &&
                            <CustomTooltip title={'Link form di registrazione'} children={
                                <Button aria-label="add"
                                        sx={{ml: 0.5}}
                                        variant={'outlined'}
                                        color={'accent'}
                                        size={'small'}
                                        startIcon={<Preview/>}
                                        href={`https://kampaay.meetwinston.co/${event_id}/register/${activeForm?.id}`}
                                        target={'_blank'}
                                >
                                    Link form di registrazione
                                </Button>
                            }/>}
                        {activeForm?.main &&
                            <CustomTooltip title={`${!settings.registrationClosed ? 'Chiudi' : 'Apri'} iscrizioni`} children={
                                <Button aria-label="add"
                                        sx={{ml: 0.5}}
                                        variant={'outlined'}
                                        color={'accent'}
                                        size={'small'}
                                        startIcon={settings.registrationClosed ? <Lock/> : <LockOpen/>}
                                        onClick={handleToggleRegistrationsClosed}
                                >
                                    {`Iscrizioni ${settings.registrationClosed ? 'Chiuse' : 'Aperte'} `}
                                </Button>
                            }/>}
                    </Box>
                    <Box display={'flex'} alignItems={'center'}>
                        <CustomToggleGraph graphMode={graphMode} handleGraphMode={handleGraphMode}/>
                    </Box>
                </Box>
                <div style={{display: 'flex', height: 670,}}>
                    <div style={{flexGrow: 1}}>
                        <Tabs variant={'standard'} value={activeForm?.position} onChange={handleChangeActiveTab}
                              aria-label="forms tabs"
                              sx={{overflow: "visible",
                                  "& .MuiTabs-scroller": {overflow: "visible !important"},
                              }}>
                            {
                                _forms && _forms?.map((tab) => {
                                    if (tab.id === forms.CHECKIN.id)
                                        return <Tab key={tab.id}
                                                    sx={{
                                                        //background: alpha(customTheme.palette.primary.main, 0.1),
                                                        //borderRadius: '8px 8px 0 0',
                                                        //marginLeft: 'auto',
                                                    }}
                                                    label={<Stack direction={'row'} alignItems={'center'}>
                                                        {`${tab.label}`}
                                                        <Chip
                                                            label={`${_.filter(usersPerForm[tab.id], ['checkin', true])?.length} / ${usersPerForm[tab.id]?.length}`}
                                                            //size={'small'}
                                                            //color={'primary'}
                                                            sx={{
                                                                marginLeft: 1,
                                                                background: tab.id === activeForm?.id ? paletteKampaay.accent2 : alpha(paletteKampaay.accent2, 0.15),
                                                                color: tab.id === activeForm?.id ? 'white' : 'inherit'
                                                            }}
                                                        />
                                                    </Stack>}/>
                                    return <Tab key={tab.id}
                                                sx={{
                                                    /*background: tab.id === activeForm?.id ?
                                                        alpha(customTheme.palette.accent.main, 0.3)
                                                        : alpha(customTheme.palette.accent.main, 0.1),
                                                    borderRadius: '8px 8px 0 0',
                                                    marginRight: 1*/
                                                }}
                                                label={<Stack direction={'row'} alignItems={'center'}>
                                                        {`${tab.label}`}
                                                        <Chip label={filter(usersPerForm[tab.id], function (o) {
                                                            return o[tab.id] === true || !!o[tab.id] //|| !!o[tab.timelineField]
                                                        }).length || 0}
                                                              //size={'small'}
                                                              sx={{
                                                                  marginLeft: 1,
                                                                  background: tab.id === activeForm?.id ? paletteKampaay.accent2 : alpha(paletteKampaay.accent2, 0.15),
                                                                  color: tab.id === activeForm?.id ? 'white' : 'inherit'
                                                              }}
                                                        />
                                                    </Stack>}
                                    />
                                })
                            }
                            <Tab sx={{
                                background: forms.ARCHIVED.id === activeForm?.id ?
                                    alpha(customTheme.palette.accent.main, 0.2) : '',
                                borderRadius: '8px 8px 0 0',
                                padding: 0,
                                marginLeft: 'auto',
                                //marginLeft: globalState.settings?.checkin ? 'inherit' : 'auto',
                            }}
                                 disabled={readOnly}
                                 label={<Chip
                                     variant={'outlined'}
                                     label={'Utenti archiviati'}
                                     icon={<FolderSharedOutlined fontSize={'small'} color={!readOnly ? 'primary' : 'disabled'}/>}/>}
                            />
                            <ArchivedUsersDialog openArchivedDialog={openArchivedDialog}
                                                 setOpenArchivedDialog={setOpenArchivedDialog}
                                                 refetch={fetchUsers}
                            />
                        </Tabs>
                        {
                            reports && !isEmpty(reports) &&
                            <Grow in={reports && !isEmpty(reports)}>
                                <Stack py={1} direction={'row'} justifyContent={'space-between'} alignItems={'center'}>
                                    <Stack direction={'row'} alignItems={'center'} spacing={0.8}
                                            sx={{
                                               /*background: activeForm.id === forms.CHECKIN.id ?
                                                   alpha(customTheme.palette.primary.main, 0.1)
                                                   : alpha(customTheme.palette.accent.main, 0.1)*/
                                           }}>
                                        {
                                            Object.entries(reports || []).map(([key, value], i) => {
                                                return <Chip key={i}
                                                             sx={{fontWeight: 'bold',background: alpha(paletteKampaay.accent2, 0.15)}}
                                                    //size={'small'} //color={'primary'} variant={'accent-outlined'}
                                                             label={`${key}: ${value || 0}`}/>
                                            })
                                        }
                                    </Stack>
                                    {activeForm.id === forms.CHECKIN.id &&
                                        <QrCodeAppCheckin title={'Mostra QR code Check-in '} size={'small'} color={'accent'}/>}
                                </Stack>
                            </Grow>
                        }
                        {!graphMode ?
                            <DataGrid
                                localeText={{
                                    ...itIT.components.MuiDataGrid.defaultProps.localeText,
                                    toolbarExport: "Esporta colonne visibili"
                                }}
                                loading={loadingUsers || loadingConfig}
                                columnVisibilityModel={columnVisibilityModel}
                                onColumnVisibilityModelChange={(newModel) =>
                                    handleSaveConfiguration(newModel)
                                }
                                onRowClick={(params, event, details) => {
                                    if(!checkboxSelection)
                                        navigate(`/${event_id}/iscrizioni/user/${params.row.id}`, {state: {activeFormId: activeForm?.id}});
                                }}
                                //density={'compact'}
                                componentsProps={{
                                    toolbar: {
                                        showQuickFilter: true,
                                        quickFilterProps: { debounceMs: 500 },
                                    },
                                }}
                                components={{
                                    Toolbar: () => <CustomGridToolbar buttons={!readOnly ? [
                                        <MultipleSelection
                                            selectedForm={activeForm}
                                            checkboxSelection={checkboxSelection}
                                            setCheckboxSelection={setCheckboxSelection}
                                            rowSelectionModel={rowSelectionModel}
                                            setRowSelectionModel={setRowSelectionModel}
                                            refetchUsers={fetchUsers}
                                            //openConfirmDialog={openConfirmDialog}
                                            //handleToggleConfirmDialog={handleToggleConfirmDialog}
                                        />] : null}/>,
                                    LoadingOverlay: LinearProgress,
                                }}
                                pageSize={pageSize}
                                onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                                rowsPerPageOptions={[10, 20, 50]}
                                columns={!loadingConfig ? (columns || []) : []}
                                rows={filteredUsers || []}
                                //checkboxSelection={true}
                                disableSelectionOnClick={!checkboxSelection}
                                checkboxSelection={checkboxSelection}
                                selectionModel={rowSelectionModel}
                                onSelectionModelChange={(newRowSelectionModel) => {
                                    //console.log("newRowSelectionModel:",newRowSelectionModel)
                                    setRowSelectionModel(newRowSelectionModel);
                                }}
                            />
                            : <CustomDashboardGraph
                                utenti={filteredUsers}
                                activeForm={activeForm}/>
                        }
                    </div>
                </div>
                <Fab onClick={fetchUsers}
                     color={'primary'}
                     size={"medium"}
                     variant={'action'}>
                    <CachedOutlined/>
                </Fab>
            </Box>
            <AddUserDialog
                dialogState={addUserDialogState}
                handleClose={handleCloseAddUserDialog}
                formId={activeForm?.id !== forms.CHECKIN.id ? activeForm?.id : (find(dataStructures, ['main', true])?.id || '')}
                setError={setError}/>
        </Box>
    )
}

export default Iscrizioni
